import React, { HTMLAttributes, useState } from 'react';
import styled from 'styled-components';

interface VideoCoverProps extends HTMLAttributes<HTMLVideoElement> {
  src: string;
  width: number;
  height: number;
}

export const VideoCover: React.FC<VideoCoverProps> = ({
  src, width, height, onCanPlay, ...props
}) => {
  const [isVideoLoaded, setIsVideoLoaded] = useState(false);

  const handleCanPlay = (event: React.SyntheticEvent<HTMLVideoElement>) => {
    setIsVideoLoaded(true);
    // Вызываем внешний обработчик, если он передан
    if (onCanPlay) {
      onCanPlay(event);
    }
  };

  return (
    <SCVideo
      src={src}
      width={width}
      height={height}
      autoPlay
      loop
      muted
      playsInline
      onLoadStart={() => {
        setIsVideoLoaded(false);
      }}
      onCanPlay={handleCanPlay}
      preload="none"
      data-loaded={isVideoLoaded}
      {...props}
    />
  );
};

const SCVideo = styled.video`
  position: absolute;
  top: 0;
  width: 100%;
  height: auto;
  max-height: 100%;
  z-index: 2;
  border-radius: 4px;
  display: block;
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
  object-fit: cover;

  &[data-loaded="true"] {
    opacity: 1;
    pointer-events: auto;
    visibility: visible;
    z-index: 3;
  }
`;
